/**
 *基于mitt封装与原生通信事件
 *
 */
import mitt from "@/utils/mitt";

class NativeBridge {
  constructor() {
    window["callBack"] = (tp, result) => {
      this.emit(tp, result);
    };
  }
  on(method, fn: VoidFunction) {
    mitt.on(method, fn);
  }
  off(method, fn: VoidFunction) {
    mitt.off(method, fn);
  }
  send(method, param: any) {
    callAppFunction(method, param);
  }
  emit(method, param) {
    console.log("app>>h5》》method:" + method + "  》》参数" + decodeURI(JSON.stringify(param)));
    mitt.emit(method, param);
  }
  toast(message, time = 3000) {
    callAppFunction("toast", { msg: encodeURI(message), time: time });
  }
  clear() {
    mitt.all.clear();
  }
}

function callAppFunction(method, param) {
  if (param == null) {
    return;
  }
  param = "string" == typeof param ? JSON.parse(param) : param;

  param.sn = param.sn + "";
  if (Number(param.sn).toString() == "NaN") {
    param.sn = "0";
  }

  let hrefs: string[] = [];
  hrefs.push("appclient://");
  let data = {};
  data["method"] = method;
  data["data"] = param;
  hrefs.push(JSON.stringify(data));
  console.log("H5>>app》》method:" + method + "  》》参数" + decodeURI(JSON.stringify(data)));
  if (!navigator.platform.includes("Linux")) {
    return;
  }
  window.location.href = hrefs.join("");
}
export default NativeBridge;
